import React from 'react';
import PropTypes from 'prop-types';
import { indexOf } from 'lodash';
import { Link } from 'react-router-dom';


function LabelCellRenderer(props) {
  const { value, data, deletingTeams, user } = props;
  const id = data._id;
  const disabled = indexOf(deletingTeams, id) >= 0;


  const lbl = <span>{value}</span>;

  let author = null;
  if (data.owner) {
    if (data.owner._id !== user._id) {
      author = (<span className="text-muted">&nbsp;<em>by: {data.owner.display_name}</em></span>);
    }
  }

  if (disabled) {
    return <span>{lbl} {author}</span>;
  }
  return (
    <span><Link to={`teams/${id}`}>{lbl}</Link> {author}</span>
  );
}

LabelCellRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    _id: PropTypes.string,
    owner: PropTypes.shape({
      _id: PropTypes.string,
      display_name: PropTypes.string,
    }),
  }).isRequired,
  deletingTeams: PropTypes.arrayOf(PropTypes.string),
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};
LabelCellRenderer.defaultProps = {
  value: null,
  deletingTeams: [],
};
export default LabelCellRenderer;
